import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AdminLayout({ children }) {
  const { logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: "/admin", label: "Dashboard" },
    { path: "/admin/new", label: "New Post" },
  ];

  return (
    <div className="min-h-screen">
      <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-20 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/admin" className="font-bold text-lg">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue to-tech-green">
                Admin
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                    location.pathname === item.path
                      ? "bg-cyber-blue/20 text-cyber-blue"
                      : "text-gray-400 hover:text-white hover:bg-white/5"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/blog"
              className="text-sm text-gray-400 hover:text-white transition-colors"
            >
              View Blog
            </Link>
            <button
              onClick={logout}
              className="px-4 py-1.5 rounded-lg text-sm font-medium text-gray-400 hover:text-red-400 hover:bg-red-500/10 transition-all"
            >
              Sign Out
            </button>
          </div>
        </div>
      </nav>

      <main className="pt-24 pb-16 px-6 lg:px-20 max-w-7xl mx-auto">
        {children}
      </main>
    </div>
  );
}
